import { memo } from 'react';

import { Menu } from '@headlessui/react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Icon, Popup, UiButton } from '@shared/ui';

import { useDropdown } from './useDropdown';
import { saveFile } from '../../../../helpers/saveFile';
import cls from '../ProgressCard.module.css';

interface DropdownProps {
    fileId: string;
    is_customer?: boolean;
    progress_tariff_access_edit?: boolean;
}

export const Dropdown = memo(
    ({ fileId, is_customer, progress_tariff_access_edit }: DropdownProps) => {
        const {
            onEdit,
            onDelete,
            original_url,
            video_url,
            onShowDelete,
            isShowPopup,
            onHidePopup,
            onSelect,
        } = useDropdown(fileId);

        const { t } = useTranslation();

        return (
            <>
                <Popup
                    isOpen={isShowPopup}
                    onHidePopup={onHidePopup}
                    btnActionCb={onDelete}
                    type="delete"
                    deleteButtonText={t('Dropdown.return.popup.danger')}
                    cancelButtonText={t('Dropdown.return.popup.cancel')}
                    popupContentClassName={cls.secondModal}
                    contentText={t('Dropdown.return.popup.text')}
                />
                {is_customer || !progress_tariff_access_edit ? (
                    <UiButton
                        className={classNames(cls.menu, cls.save)}
                        onClick={async () => {
                            await saveFile(original_url);
                        }}
                        variant="icon"
                        startIcon={
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0.5 9.8999C0.632608 9.8999 0.759785 9.95258 0.853553 10.0463C0.947322 10.1401 1 10.2673 1 10.3999V12.8999C1 13.1651 1.10536 13.4195 1.29289 13.607C1.48043 13.7945 1.73478 13.8999 2 13.8999H14C14.2652 13.8999 14.5196 13.7945 14.7071 13.607C14.8946 13.4195 15 13.1651 15 12.8999V10.3999C15 10.2673 15.0527 10.1401 15.1464 10.0463C15.2402 9.95258 15.3674 9.8999 15.5 9.8999C15.6326 9.8999 15.7598 9.95258 15.8536 10.0463C15.9473 10.1401 16 10.2673 16 10.3999V12.8999C16 13.4303 15.7893 13.939 15.4142 14.3141C15.0391 14.6892 14.5304 14.8999 14 14.8999H2C1.46957 14.8999 0.960859 14.6892 0.585786 14.3141C0.210714 13.939 0 13.4303 0 12.8999V10.3999C0 10.2673 0.0526784 10.1401 0.146447 10.0463C0.240215 9.95258 0.367392 9.8999 0.5 9.8999Z"
                                    fill="black"
                                />
                                <path
                                    d="M7.64602 11.854C7.69247 11.9006 7.74764 11.9375 7.80839 11.9627C7.86913 11.9879 7.93425 12.0009 8.00002 12.0009C8.06579 12.0009 8.13091 11.9879 8.19165 11.9627C8.2524 11.9375 8.30758 11.9006 8.35402 11.854L11.354 8.854C11.4479 8.76011 11.5007 8.63278 11.5007 8.5C11.5007 8.36722 11.4479 8.23989 11.354 8.146C11.2601 8.05211 11.1328 7.99937 11 7.99937C10.8672 7.99937 10.7399 8.05211 10.646 8.146L8.50002 10.293V1.5C8.50002 1.36739 8.44734 1.24021 8.35358 1.14645C8.25981 1.05268 8.13263 1 8.00002 1C7.86741 1 7.74024 1.05268 7.64647 1.14645C7.5527 1.24021 7.50002 1.36739 7.50002 1.5V10.293L5.35402 8.146C5.26013 8.05211 5.1328 7.99937 5.00002 7.99937C4.86725 7.99937 4.73991 8.05211 4.64602 8.146C4.55213 8.23989 4.49939 8.36722 4.49939 8.5C4.49939 8.63278 4.55213 8.76011 4.64602 8.854L7.64602 11.854Z"
                                    fill="black"
                                />
                            </svg>
                        }
                    />
                ) : (
                    <Menu>
                        <Menu.Button
                            onClick={(event) => {
                                event.stopPropagation();
                                // onChangeCurrentFile(fileId);
                            }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    event.preventDefault();
                                    event.stopPropagation();
                                }
                            }}
                            className={cls.menu}
                        >
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11.2383 5.26172C11.2383 5.95207 10.6787 6.51172 9.98834 6.51172C9.29799 6.51172 8.73834 5.95207 8.73834 5.26172C8.73834 4.57136 9.29799 4.01172 9.98834 4.01172C10.6787 4.01172 11.2383 4.57136 11.2383 5.26172Z"
                                    fill="#252733"
                                />
                                <path
                                    d="M11.2633 10.0122C11.2633 10.7026 10.7036 11.2622 10.0133 11.2622C9.32293 11.2622 8.76329 10.7026 8.76329 10.0122C8.76329 9.32185 9.32293 8.76221 10.0133 8.76221C10.7036 8.76221 11.2633 9.32185 11.2633 10.0122Z"
                                    fill="#252733"
                                />
                                <path
                                    d="M11.2368 14.7617C11.2368 15.4521 10.6772 16.0117 9.98682 16.0117C9.29646 16.0117 8.73682 15.4521 8.73682 14.7617C8.73682 14.0714 9.29646 13.5117 9.98682 13.5117C10.6772 13.5117 11.2368 14.0714 11.2368 14.7617Z"
                                    fill="#252733"
                                />
                            </svg>
                        </Menu.Button>
                        <Menu.Items className={cls.menuItems}>
                            <Menu.Item className={cls.item}>
                                <span
                                    onClick={async (event) => {
                                        event.stopPropagation();
                                        await saveFile(video_url ?? original_url);
                                    }}
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M0.5 9.8999C0.632608 9.8999 0.759785 9.95258 0.853553 10.0463C0.947322 10.1401 1 10.2673 1 10.3999V12.8999C1 13.1651 1.10536 13.4195 1.29289 13.607C1.48043 13.7945 1.73478 13.8999 2 13.8999H14C14.2652 13.8999 14.5196 13.7945 14.7071 13.607C14.8946 13.4195 15 13.1651 15 12.8999V10.3999C15 10.2673 15.0527 10.1401 15.1464 10.0463C15.2402 9.95258 15.3674 9.8999 15.5 9.8999C15.6326 9.8999 15.7598 9.95258 15.8536 10.0463C15.9473 10.1401 16 10.2673 16 10.3999V12.8999C16 13.4303 15.7893 13.939 15.4142 14.3141C15.0391 14.6892 14.5304 14.8999 14 14.8999H2C1.46957 14.8999 0.960859 14.6892 0.585786 14.3141C0.210714 13.939 0 13.4303 0 12.8999V10.3999C0 10.2673 0.0526784 10.1401 0.146447 10.0463C0.240215 9.95258 0.367392 9.8999 0.5 9.8999Z"
                                            fill="black"
                                        />
                                        <path
                                            d="M7.64602 11.854C7.69247 11.9006 7.74764 11.9375 7.80839 11.9627C7.86913 11.9879 7.93425 12.0009 8.00002 12.0009C8.06579 12.0009 8.13091 11.9879 8.19165 11.9627C8.2524 11.9375 8.30758 11.9006 8.35402 11.854L11.354 8.854C11.4479 8.76011 11.5007 8.63278 11.5007 8.5C11.5007 8.36722 11.4479 8.23989 11.354 8.146C11.2601 8.05211 11.1328 7.99937 11 7.99937C10.8672 7.99937 10.7399 8.05211 10.646 8.146L8.50002 10.293V1.5C8.50002 1.36739 8.44734 1.24021 8.35358 1.14645C8.25981 1.05268 8.13263 1 8.00002 1C7.86741 1 7.74024 1.05268 7.64647 1.14645C7.5527 1.24021 7.50002 1.36739 7.50002 1.5V10.293L5.35402 8.146C5.26013 8.05211 5.1328 7.99937 5.00002 7.99937C4.86725 7.99937 4.73991 8.05211 4.64602 8.146C4.55213 8.23989 4.49939 8.36722 4.49939 8.5C4.49939 8.63278 4.55213 8.76011 4.64602 8.854L7.64602 11.854Z"
                                            fill="black"
                                        />
                                    </svg>
                                    {t('Dropdown.return.menu.item.span.save')}
                                </span>
                            </Menu.Item>
                            <Menu.Item className={cls.item}>
                                <span
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onEdit();
                                    }}
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9.42841 2.18634C8.95706 2.2333 8.50393 2.46317 8.17454 2.86544L1.76423 10.6943L1.75011 10.8378L1.50435 13.3632L1.46346 13.7323C1.44751 13.8763 1.58508 13.9889 1.72305 13.9449L2.07682 13.832L4.50413 13.0928L4.64203 13.0506L11.0523 5.2218C11.7111 4.41726 11.5962 3.26349 10.7916 2.60472C10.3893 2.27534 9.89977 2.13938 9.42841 2.18634ZM9.51392 3.04463C9.7408 3.02203 9.97978 3.10302 10.2215 3.30096C10.7031 3.69528 10.7504 4.17015 10.3561 4.65171L10.0633 4.9935L8.59348 3.78998L8.87078 3.43553C9.06873 3.19378 9.28703 3.06723 9.51392 3.04463ZM8.02339 4.48622L9.49323 5.68974L4.59048 11.6774C4.23754 11.13 3.72696 10.7119 3.12064 10.4739L8.02339 4.48622ZM2.61665 11.263C3.17832 11.4273 3.64442 11.809 3.9163 12.3272L2.46835 12.7698L2.61665 11.263Z"
                                            fill="#252733"
                                        />
                                        <path
                                            d="M6 13.5C6 13.2239 6.22386 13 6.5 13H13.5C13.7761 13 14 13.2239 14 13.5C14 13.7761 13.7761 14 13.5 14H6.5C6.22386 14 6 13.7761 6 13.5Z"
                                            fill="#252733"
                                        />
                                    </svg>
                                    {t('Dropdown.return.menu.item.span.edit')}
                                </span>
                            </Menu.Item>
                            <Menu.Item className={cls.item}>
                                <span
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onSelect();
                                    }}
                                >
                                    <Icon iconName="checkboxes" width={16} height={16} />
                                    {t('Dropdown.return.menu.item.span.select')}
                                </span>
                            </Menu.Item>
                            <Menu.Item className={classNames(cls.item, cls.delete)}>
                                <span
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onShowDelete();
                                    }}
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M11.3333 14.6668H4.66667C3.93029 14.6668 3.33333 14.0699 3.33333 13.3335V4.66683H2V3.3335H4.66667V2.66683C4.66667 1.93045 5.26362 1.3335 6 1.3335H10C10.7364 1.3335 11.3333 1.93045 11.3333 2.66683V3.3335H14V4.66683H12.6667V13.3335C12.6667 14.0699 12.0697 14.6668 11.3333 14.6668ZM4.66667 4.66683V13.3335H11.3333V4.66683H4.66667ZM6 2.66683V3.3335H10V2.66683H6ZM10 12.0002H8.66667V6.00016H10V12.0002ZM7.33333 12.0002H6V6.00016H7.33333V12.0002Z"
                                            fill="#E04E2A"
                                        />
                                    </svg>
                                    {t('Dropdown.return.menu.item.span.delete')}
                                </span>
                            </Menu.Item>
                        </Menu.Items>
                    </Menu>
                )}
            </>
        );
    }
);
